import { MODULE } from "./search-filter.actionTypes";

export const getSearch = (state) => state.getIn([MODULE, "search"]);

export default {};
